import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    headerContainer: {
      padding: '24px 40px',
      justifyContent: 'space-between',
      background: 'transparent',
      display: 'flex',
      height: '100px',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        height: 'auto'
      },
      [theme.breakpoints.only('sm')]: {
        alignItems: 'baseline',
        gap: '24px',
        padding: '24px 30px'
      },
      [theme.breakpoints.only('xs')]: {
        gap: '16px',
        justifyContent: 'center',
        padding: '16px 24px'
      }
    },
    header: {
      fontSize: '40px',
      fontWeight: 600,
      lineHeight: '1',
      [theme.breakpoints.only('xs')]: {
        fontSize: '32px'
      }
    },
    tableOuterBox: {
      flex: 1,
      minHeight: 0,
      background: 'transparent',
      padding: '0px 40px',
      overflow: 'visible',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        padding: '5px 20px 20px'
      }
    },
    nameTableCell: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      paddingLeft: '24px'
    },
    integrationsTableCell: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600
    },
    sortableTableCell: {
      cursor: 'pointer',
      userSelect: 'none'
    },
    actionsTableCell: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      width: '160px',
      textAlign: 'center'
    },
    footerContainer: {
      width: '100%',
      overflow: 'hidden',
      padding: '0px 40px',
      margin: 0
    },
    total: {
      float: 'right',
      fontSize: '20px',
      padding: '24px 0 0',
      fontWeight: 900,
      margin: 0
    },
    selectedRow: {
      borderWidth: 0,
      borderLeftWidth: 20,
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: 'white'
    },
    actionIconsBox: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      [theme.breakpoints.down('lg')]: {
        width: '160px'
      }
    },
    overlayInnerContainer: {
      width: '524px',
      [theme.breakpoints.only('xs')]: {
        width: '262px'
      }
    },
    overlayFieldBox: {
      height: '110px',
      minHeight: '110px',
      width: '100%'
    },
    overlayFieldLabel: {
      fontSize: '16px',
      fontWeight: 600,
      marginBottom: '10px',
      padding: '0 16px'
    },
    overlayMultiSelect: {
      width: '100%',
      minHeight: '45px',
      borderRadius: '50px',
      color: 'grey',
      '& .MuiSelect-select': {
        padding: '8px 26px'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${color.BORDER}`
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${color.BORDER}`,
        boxShadow: 'inset 0 0 10px 0 rgba(0, 0, 0, 0.15)'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${color.BORDER}`,
        boxShadow: 'inset 0 0 10px 0 rgba(0, 0, 0, 0.15)'
      }
    }
  })
);
